<template>
    <div>
        <b-container fluid>
            <div v-for="(rule, index) in filteredStylingRules" :key="index">
                <div v-for="(type, index1) in geometryType" :key="index1">
                    <b-row class="legend-row">
                        <b-col class="fixed-col legend-col">
                            <img
                                v-if="
                                    type === geometryTypeConst.POINT &&
                                    rule.icon
                                "
                                :src="$_getIcon(rule)"
                                style="width: 15px"
                                alt="Icon"
                            />
                            <div
                                v-else-if="
                                    type === geometryTypeConst.POINT &&
                                    !rule.icon
                                "
                                :style="$_getStylePointObject(rule, true)"
                                class="legendpoint"
                            ></div>
                            <div
                                v-else-if="type === geometryTypeConst.LINE"
                                :style="$_getStyleLineObject(rule)"
                            ></div>
                            <div
                                v-else-if="type === geometryTypeConst.POLYGON"
                                :style="$_getStylePointObject(rule, false)"
                            ></div>
                        </b-col>
                        <b-col class="legend-col">
                            {{ rule.title }}
                        </b-col>
                    </b-row>
                </div>
            </div>
        </b-container>
    </div>
</template>

<script>
    import {
        CUSTOM_STYLING_RULE_OTHER,
        FEEDBACKS_GEOMETRY_TYPE_CODES
    } from '../../../../constants';

    export default {
        props: {
            geometryType: { type: Array, required: true },
            customStylingOptions: { type: Object, required: true },
            hideFill: { type: Boolean, required: false, default: false }
        },
        data() {
            return { geometryTypeConst: FEEDBACKS_GEOMETRY_TYPE_CODES };
        },
        computed: {
            filteredStylingRules() {
                return this.customStylingOptions.rules.filter((rule) => {
                    return this.customStylingOptions.useOtherRule === false
                        ? rule.filterLiteral !== CUSTOM_STYLING_RULE_OTHER
                        : true;
                });
            }
        },
        methods: {
            $_getIcon(rule) {
                return rule.iconReplacedParams || rule.icon;
            },
            $_getStyleLineObject(layerStyle) {
                return {
                    width: '15px',
                    height: '15px',
                    'border-bottom': `${layerStyle.strokeWidth}px solid ${layerStyle.fillColor}`,
                    'margin-right': '10px',
                    '-webkit-transform': 'rotate(-45deg)',
                    position: 'absolute',
                    top: '-12px',
                    left: '-4px'
                };
            },
            $_getStylePointObject(layerStyle, isPoint) {
                const color = this.hideFill ? 'transparent' : layerStyle.fillColor;
                return {
                    ...(layerStyle.imageSvg &&
                        !isPoint && {
                            'background-image': `url('${layerStyle.imageSvg}')`,
                            'background-repeat': 'no-repeat',
                            'background-position': 'center'
                        }),
                    'background-color': color,
                    width: '15px',
                    height: '15px',
                    border: `${layerStyle.strokeWidth}px solid ${layerStyle.strokeColor}`,
                    'margin-right': '10px'
                };
            }
        }
    };
</script>

<style scoped>
.fixed-col {
    flex: 0 0 25px;
}

.legend-row {
    padding: 1px 0px;
}

.legend-col {
    align-self: center;
    padding-left: 0px;
    padding-right: 0px;
    word-break: break-word;
}

.legendpoint {
    border-radius: 50%;
    display: block;
}
</style>
